<style lang="scss" scoped>
/deep/ .comp-employee-records-dialog {
    max-width: 860px;
}
</style>

<template>
    <div class="comp-employee-records">
        <el-dialog :title="dialogTitle" custom-class="c-el-dialog comp-employee-records-dialog"
            :visible.sync="showDialog" :before-close="_close">
            <el-table :data="tableData" style="width: 100%" border size="small">
                <el-table-column label="类型" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag size="medium" type="success" v-if="scope.row.type === valEmployeeRecordTypeHire()">入职</el-tag>
                        <el-tag size="medium" type="info" v-else>离职</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="生效日期" prop="effectiveDate" :formatter="formatDate" width="110"></el-table-column>
                <el-table-column label="来源" width="100" align="center">
                    <template slot-scope="scope">{{ sourceDesc(scope.row.source) }}</template>
                </el-table-column>
                <el-table-column label="备注" prop="remark" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column label="记录时间" prop="creationTime" :formatter="formatDateTime" width="150"
                    v-if="$root.isPc"></el-table-column>
                <el-table-column label="操作" width="80" align="center"
                    v-if="isEmployeeArchiveManage">
                    <template slot-scope="scope">
                        <el-button type="danger" plain size="mini" v-if="scope.row.source === 2"
                            @click="_delete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container" v-if="isPagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="listQuery.page" :page-sizes="appPageSizes" :page-size="listQuery.size"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import permission from "@/mixins/permission"
import enumConfigs from "@/mixins/enumConfigs"
import * as funEmployee from "@/api/employees"
import moment from "moment"

export default {
    name: "compEmployeeRecords",
    mixins: [permission, enumConfigs],
    data() {
        return {
            showDialog: false,
            current: {},
            tableData: [],
            total: null,
            isPagination: false,
            listQuery: {
                idNumber: "",
                page: 1,
                size: window.$common.appPageSize
            }
        }
    },
    computed: {
        dialogTitle() {
            return this.current.name ? `入离职记录 - ${this.current.name}` : "入离职记录"
        }
    },
    methods: {
        open(row) {
            this.current = row || {}
            this.listQuery.idNumber = this.current.idNumber || ""
            this.listQuery.page = 1
            this.showDialog = true
            this.getDataList()
        },
        handleSizeChange(val) {
            window.$common.fullLoading()
            this.listQuery.size = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            window.$common.fullLoading()
            this.listQuery.page = val
            this.getDataList()
        },
        // 获取入离职记录列表
        getDataList() {
            window.$common.fullLoading()
            let params = JSON.parse(JSON.stringify(this.listQuery))
            funEmployee.GetEmployeeEmploymentRecords(params).then(response => {
                window.$common.closeFullLoading()
                this.total = response.totalCount
                this.isPagination = response.totalCount > 0 || false
                this.tableData = response.items || []
            })
        },
        // 来源描述
        sourceDesc(value) {
            let item = (this.arrEmploymentRecordSource || []).find(x => x.value === value)
            return item ? item.desc : value
        },
        // 日期格式化（空值显示空白）
        formatDate(row, column, cellValue) {
            return cellValue ? moment(cellValue).format("YYYY-MM-DD") : ""
        },
        formatDateTime(row, column, cellValue) {
            return cellValue ? moment(cellValue).format("YYYY-MM-DD HH:mm:ss") : ""
        },
        _delete(row) {
            this.confirm("确定要删除该入离职记录吗？删除后员工状态将按剩余记录重算。").then(() => {
                window.$common.fullLoading()
                funEmployee.DeleteEmployeeEmploymentRecord({ id: row.id }).then(() => {
                    this.successMsg("删除成功!")
                    this.getDataList()
                    this.$emit("refreshData", row)
                })
            })
        },
        _close() {
            this.showDialog = false
        }
    }
}
</script>
